const fr = {
  link: {
    enter_link_title_en: "Entrer le titre du lien",
    enter_link: "Entrer le lien",
    add_icon: "AJOUTER UNE ICÔNE",
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    link_cap: "LIEN",
    add: "Ajouter",
    edit: "Modifier",
    link_is_required: "Le titre du lien est requis",
    link_url_required: "URL du lien requise",
    select_lang: "Sélectionnez une langue",
  },
  avatar: {
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    add: "Ajouter",
    edit: "Modifier",
    avatar: "Avatar",
    drop_your_img: "Déposez votre image ici ou",
    browse_image: "PARCOURIR L'IMAGE",
    maximum: "Maximum",
    choose_another: "CHOISIR UN AUTRE",
    size: "Taille",
    select_lang: "Sélectionnez une langue",
    shape: "Forme",
  },
  qr_code: {
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    add: "Ajouter",
    edit: "Modifier",
    select_lang: "Sélectionnez une langue",
    Qr_code: "Code QR",
  },
  texteditor: {
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    add: "Ajouter",
    edit: "Modifier",
    select_lang: "Sélectionnez une langue",
    text: "TEXTE",
  },
  faq: {
    faq: "FAQ",
    add_faq: "Ajouter des questions fréquemment posées (FAQ)",
    select_lang: "Sélectionnez une langue",
    question_required: "Question requise",
    answer_required: "Réponse requise",
    enter_question: "Entrer la question",
    enter_answer: "Entrer la réponse",
    add: "Ajouter",
    edit: "Modifier",
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
  },
  media: {
    enter_link: "Entrer le lien",
    save_cap: "ENREGISTRER",
    select_lang: "Sélectionnez une langue",
    add: "Ajouter",
    edit: "Modifier",
    delete_cap: "SUPPRIMER",
  },
  image: {
    image: "Image",
    drop_your_img: "Déposez votre image ici ou",
    browse_image: "PARCOURIR L'IMAGE",
    maximum: "Maximum",
    description: "Description",
    select_lang: "Sélectionnez une langue",
    add: "Ajouter",
    edit: "Modifier",
    enter_alt_text: "Entrer le texte alternatif",
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    choose_another: "CHOISIR UN AUTRE",
  },
  imagegrid: {
    add_image_grid: "Ajouter une grille d'images",
    maximum: "Maximum",
    select_lang: "Sélectionnez une langue",
    drop_your_img: "Déposez votre image ici ou",
    browse_image: "PARCOURIR L'IMAGE",
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    add: "Ajouter",
    edit: "Modifier",
    image_grid: "Grille d'images",
  },
  divider: {
    divider: "Séparateur",
    divider_cap: "SÉPARATEUR",
    select_lang: "Sélectionnsez une langue",
    color: "Couleur",
    add_divider: "AJOUTER UN SÉPARATEUR",
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    add: "Ajouter",
    edit: "Modifier",
  },
  addcountdown: {
    countdown: "Compte à rebours",
    add_countdown: "AJOUTER UN COMPTE À REBOURS",
    select_lang: "Sélectionner une langue",
    enter_countdown_description: "Entrez la description du compte à rebours",
    choose_date: "Choisissez une date",
    choose_time: "Choisissez une heure",
    timer_digit_color: "Couleur des chiffres du minuteur",
    timer_background_color: "Couleur de fond du minuteur",
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    edit_countdown: "MODIFIER LE COMPTE À REBOURS",
  },
  header: {
    header: "En-tête",
    add_header: "AJOUTER UN EN-TÊTE",
    enter_page_name: "Entrer le nom de la page",
    enter_page_title: "Entrer le titre de la page",
    pagename_required: "Le nom de la page est requis",
    pagetitle_required: "Le titre de la page est requis",
    contact_required: "Le contact est requis",
    edit_header: "MODIFIER L'EN-TÊTE",
    whatapp_required: "WhatsApp est requis",
    whatapp: "WhatsApp",
    profile_alignment: "ALIGNEMENT DU PROFIL",
    left: "Gauche",
    center: "Centre",
    right: "Droite",
    want_to_set_background_image: "VOUS VOULEZ DÉFINIR L'IMAGE D'ARRIÈRE-PLAN",
    avatar_size: "TAILLE DE L'AVATAR",
    avatar_shape: "FORME D'AVATAR",
    avatar_outline: "APERÇU DE L'AVATAR",
    image_smaller_than_3MB: "L'image doit être inférieure à 3 Mo",
    select_lang: "Sélectionner une langue",
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    choose_avatar: "CHOISIR UN AVATAR",
    contact: "Contact",
    maximum: "Maximum",
    drop_your_img: "Déposez votre image ici ou",
    browse_image: "PARCOURIR L'IMAGE",
    choose_another: "CHOISIR UN AUTRE",
    yes: "Oui",
    no: "Non",
    circle: "Cercle",
    corners: "coins",
    rounded: "Arrondi",
    straight: "Droit",
    color: "Couleur",
  },
  socials: {
    socials: "Réseaux sociaux",
    save_cap: "ENREGISTRER",
    select_lang: "Sélectionnez une langue",
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    enter: "Entrer",
  },
  location: {
    addpin: "Ajouter une épingle",
    cancel_adding_pin: "Annuler l'ajout d'une épingle",
    adress: "Adresse",
    adress_placeholder: "123, rue principale, Ville",
    phone: "Téléphone",
    phone_placeholder: "123-456-7890",
    add_location: "Ajouter un lieu",
    set_primary: "Définir comme principal",
    primary_location: "Lieu principal",
    get_directions: "Obtenir des directions",
    added_any_location: "Vous n'avez ajouté aucun emplacement",
    adress_title_caps: 'AJOUTER UN TITRE D\'ADRESSE',
    adress_details_caps: 'AJOUTER DES DÉTAILS D\'ADRESSE',
    enter_location_name: 'Entrez le nom de l\'emplacement',
    enter_location_adress: 'Entrez l\'adresse de l\'emplacement',
    enter_location_phone: 'Entrez le téléphone de l\'emplacement',
    set_default_location: 'Définir cet emplacement comme principal / par défaut',
    home: 'Accueil',
    save_cap: "ENREGISTRER",
    delete_cap: "SUPPRIMER",
    add_location: "AJOUTER UN EMPLACEMENT",
    select_lang: "Sélectionnez une langue",
    edit_location: "MODIFIER L'EMPLACEMENT",
  },
  want_to_delete: "Êtes-vous sûr de vouloir supprimer ceci ?",
  cancel: "Annuler",
  delete_cap: "SUPPRIMER",
};

export default fr;
